class LinkedItem {
    public LinkedItemId: string;
    public SiteId?: string;
    public TypeHeader: string;
    public Title: string;
    public Notes: LinkedItemNote[];

    public constructor(fields?: Partial<LinkedItem>) {
        Object.assign(this, fields);
    }
}

class LinkedItemNote {
    public LinkedItemId: string;
    public NoteId: string;
    public Timestamp: Date;
    public Note: string;
    public EmployeeContactId: string;
}

export { LinkedItem, LinkedItemNote };
